import React from 'react';
import { Box } from '@mui/material';
import { Tooltip, Typography } from '@mui/joy';
import { InfoRounded } from '@mui-symbols-material/w300';

interface Props {
    name: string;
    /** Grey line below the name — an address, or where the answer comes from. */
    subline?: string | null;
    /** Longer explanation of the subline, behind an info icon. */
    sublineHint?: string | null;
    'data-testid'?: string;
}

/** Entity name and grey subline at the top of a hero side card. */
const HeroEntity = ({ name, subline, sublineHint, 'data-testid': testId }: Props) => (
    <Box sx={{ mt: '12px', minWidth: 0 }} data-testid={testId}>
        {/* explicit colors — the dashboard widget context inherits white */}
        <Typography level="titleSmall" sx={{ color: '#333' }} noWrap>
            {name}
        </Typography>
        {subline && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', minWidth: 0 }}>
                <Typography level="bodySmall" sx={{ color: '#777' }} noWrap>
                    {subline}
                </Typography>
                {sublineHint && (
                    <Tooltip title={sublineHint} placement="top" variant="outlined" sx={{ maxWidth: 280 }}>
                        <InfoRounded tabIndex={0} aria-label={sublineHint} sx={{ fontSize: 16, color: '#999', flexShrink: 0, cursor: 'help' }} />
                    </Tooltip>
                )}
            </Box>
        )}
    </Box>
);

export default HeroEntity;
